import * as React from "react";
import {cx} from "emotion";

import "./pick-pack.scss";

import {OPTION_SIZE} from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {cs}          from "@Common/react/chain-services";
import {values}      from "@Common/utils/objects";

import {SizeChartModal} from "./size-chart-modal/size-chart-modal";

export const PickPack = (
    {
        calSelected,
        className,
        domRef,
        eh,
        outOfStockError,
        pickPackOptions,
        pickPackSizeChartUrl,
        calOptionSet,
        calOptionTest,
    }
) => outOfStockError ? (
    <div className={cx("pick-pack-option-r9y", className, eh.css)} ref={domRef.set}>
        <div className="card error" xd-qa-type="text" xd-qa-name="Out of Stock">Out of Stock</div>
    </div>
) : cs(
    ["sizeChartModal", (_, next) => !outOfStockError && SizeChartModal({url: pickPackSizeChartUrl, next,}),],
    ({sizeChartModal}) => pickPackOptions && Object.keys(pickPackOptions).sort(sizeFirstSort).map((optionName, key) => (
        <div className={cx("pick-pack-option-r9y", className)} key={key}>
            <div className="header">
                <div className="title" xd-qa-type="text" xd-qa-name={optionName}>{optionName}</div>
                <div className="actions">
                    {optionName === OPTION_SIZE && pickPackSizeChartUrl && (
                        <a onClick={() => sizeChartModal.show()} xd-qa-type="link" xd-qa-name="Size Chart">Size Chart</a>
                    )}
                </div>
            </div>
            <div className="card">
                <div className="values">
                    {values(pickPackOptions[optionName]).map((optionValue) => {
                        const selected   = calSelected?.[optionName] === optionValue;
                        const selectable = calOptionTest(optionName, optionValue);
                        return (
                            <div
                                className={cx("value", {selected, disabled: !selectable})}
                                key={optionValue}
                                onClick={() => calOptionSet(optionName, optionValue)}
                                aria-label={selectable ? undefined : "Out of stock. Click to see available options"}
                                xd-qa-type="button"
                                xd-qa-name={cx(optionValue, {selected})}
                            >
                                <div className="label">{optionValue}</div>

                                {selected && (
                                    <div className="check">
                                        <i className="fa fa-check-circle"/>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    ))
);

const sizeFirstSort = (keyA:string, keyB:string) => (
    keyA === OPTION_SIZE
        ? -1
        : keyB === OPTION_SIZE
            ? 1
            : Number(keyB < keyA) - 0.5
);

